// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__KoMSR","buttons":"Footer_buttons__1lGBr"};